/* eslint-disable no-unused-vars */
import _ from 'lodash';
import { createSetCookie, parseCookie } from '@/utils/cookie';
import Cookies from 'js-cookie';

export default (context, inject) => {
  const auth = {
    async init(user, subscriptions) {
      if (user) {
        auth.user = user
      }
      if (subscriptions) {
        context.store.commit('auth/set', { subscriptions })
      }
    },
    get user() {
      if (!context.store.state.auth.user) return {}
      const clone = JSON.parse(JSON.stringify(context.store.state.auth.user))
      return clone
    },
    set user(value) {
      context.store.commit('auth/set', { user: value })
    },
    get loggedIn() {
      return context.store.getters['auth/get'].loggedIn
    },
    set loggedIn(value) {
      context.store.commit('auth/setLoggedIn', value)
    },
    get subscriptions() {
      return context.store.state.auth.subscriptions
    },
    get loggedRakuten() {
      return context.store.getters['auth/get'].rakuten_access_token
    },
    set loggedRakuten(value) {
      context.store.commit('auth/setRakutenToken', { rakuten_access_token: value })
    },
    removeUser() {
      context.store.commit('auth/removeUser')
      context.store.commit('subsidy/remove')
    },
    async remove() {
      context.store.commit('auth/remove');
      document.cookie = createSetCookie('refresh_token', '', new Date(0));
      document.cookie = createSetCookie('userInfo', '', new Date(0));
      // ThemiStruct ログアウト
      const sdk = new IPSDK("https", process.env.VUE_APP_LOGIN_API_FQDN, "443");
      try {
          sdk.signout("POST");
      } catch (e) {
          console.log(e);
      }

      let appCookieName = 'bsBenefitOneInc';
      if (typeof process.env.VUE_APP_COOKIE_NAME !== 'undefined') {
        appCookieName = process.env.VUE_APP_COOKIE_NAME;
      }
      Cookies.remove(appCookieName);

      // ログアウト
      await context.$repositories("login").getLogout()
        .catch((e) => {
          console.log(e);
        });
      // TOP ページへ戻る
      location.href = process.env.VUE_APP_TOP_DOMAIN;
    },
    get points() {
      return _.get(context.store.getters['auth/get'].user, 'totalPoint', '0')
    },
    set points(value) {
      const userInfo = _.cloneDeep(context.store.getters['auth/get'].user)
      userInfo.totalPoint = value
      return context.store.commit('auth/set', { user: userInfo })
    },
    get cafePoint() {
      return _.get(context.store.getters["auth/get"].user, "cafePoint", null);
    },
    set cafePoint(value) {
      const userInfo = _.cloneDeep(context.store.getters["auth/get"].user);
      userInfo.cafePoint = value;
      return context.store.commit("auth/set", { user: userInfo });
    }
  }

  inject('auth', auth)
}
